import _ from 'lodash'

export const MedicationPageMode = {
  Add: 'Add',
  Edit: 'Edit',
  Delete: 'Delete',
  Unchanged: 'Unchanged'
}
export const statuses = [
  { Value: null, Text: 'Select Status' },
  { Value: 'N', Text: 'New' },
  { Value: 'C', Text: 'Changed' },
  { Value: 'L', Text: 'Long Standing' }
]
export const InfectionSites = [
  { Value: 'Urinary', Text: 'Urinary' },
  { Value: 'Respiratory', Text: 'Respiratory' },
  { Value: 'Wound', Text: 'Wound' },
  { Value: 'Skin Lesion', Text: 'Skin Lesion' },
  { Value: 'Gastrointestinal', Text: 'Gastrointestinal' },
  { Value: 'Oral', Text: 'Oral' },
  { Value: 'Blood', Text: 'Blood' },
  { Value: 'Other', Text: 'Other' }
]
export const SignSymptoms = [
  { Value: 'Cloudy foul urine', Text: 'Cloudy foul urine' },
  { Value: 'Dysuria/suprapubic or flank pain', Text: 'Dysuria/suprapubic or flank pain' },
  { Value: 'Purulent drainage/increased wound drainage', Text: 'Purulent drainage/increased wound drainage' },
  { Value: 'Erythma', Text: 'Erythma' },
  { Value: 'Temperature increase of 2 degrees x 72 hours-chills', Text: 'Temperature increase of 2 degrees x 72 hours-chills' },
  { Value: 'Increased cough or dyspnea', Text: 'Increased cough or dyspnea' },
  { Value: 'Increased sputum production or change in color', Text: 'Increased sputum production or change in color' },
  { Value: 'White patchy area in mouth', Text: 'White patchy area in mouth' },
  { Value: 'Diarrhea', Text: 'Diarrhea' },
  { Value: 'Other', Text: 'Other' }
]

export const Culture = [
  { Text: 'Blood', Value: 'Blood' },
  { Text: 'Urine', Value: 'Urine' },
  { Text: 'Wound', Value: 'Wound' }
]

export const ShowOther = (arrayList) => {
  let showOther = false
  for (var a in arrayList) {
    if (_.includes(arrayList[a], 'Other')) {
      showOther = true
      break // Stop this loop, we found it!
    }
  }
  return showOther
}

export const ShowSlidingScale = (formData) => {
  // const { formData } = this.props
  let showSliding = false
  let arrayDrugClass = formData.DrugClasses || []
  for (var a in arrayDrugClass) {
    if (_.includes(_.toLower(arrayDrugClass[a].DrugClass), 'diabetes')) {
      showSliding = true
      break // Stop this loop, we found it!
    }
  }
  return showSliding
}

export const ShowInfectionControl = (formData) => {
  // const { formData } = this.props
  let showInfection = false
  const bacteriaList = ['antibacterial', 'antimicrobial', 'antiinfective', 'antimycobacterial', 'bacterialcital', 'bacterial', 'infection']
  let arrayDrugClass = formData.DrugClasses || []
  let arrayIndications = formData.Indications || []
  _.forEach(bacteriaList, (b) => {
    for (var a in arrayDrugClass) {
      if (_.includes(_.toLower(arrayDrugClass[a].DrugClass), b)) {
        showInfection = true
        break // Stop this loop, we found it!
      }
    }
    for (var c in arrayIndications) {
      if (_.includes(_.toLower(arrayIndications[c].Indication), b)) {
        showInfection = true
        break // Stop this loop, we found it!
      }
    }
  })
  return showInfection
}
// export default MedicationPageMode
